import { Injectable } from '@angular/core';
import { Company, Order } from '@authority-labs/api-interfaces';
import { ModalOptions, NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import {
  AlertCompanyComponent,
  AlertCompanyOrdersComponent
} from './alert-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class AlertDialogService {
  constructor(private modal: NzModalService) {}

  companyAlert(
    company: Company,
    orders: Order[] = []
  ): NzModalRef<unknown, unknown> {
    if (company) {
      if (orders?.length > 0) {
        const modalData: ModalOptions = {
          nzTitle: 'יש הזמנות שלא שולמו',
          nzContent: AlertCompanyOrdersComponent,
          nzComponentParams: { company, orders },
          nzWidth: '60vw'
        };
        return this.modal.warning(modalData);
      } else if (company.isStatusDanger() || company.isStatusWarning()) {
        const modalData: ModalOptions = {
          nzTitle: 'סטטוס חברה לא תקין',
          nzContent: AlertCompanyComponent,
          nzComponentParams: { company }
        };

        if (company.isStatusDanger()) {
          this.modal.error(modalData);
        } else {
          return this.modal.warning(modalData);
        }
      }
    }
  }
}
